(() => {
  const ATTRIBUTE_NAME = 'customerEmail';
  const EMAIL_PATTERN = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
  const CHAT_DISCOVERY_TIMEOUT = 15_000;
  const CHAT_CAPTURE_TIMEOUT = 10 * 60 * 1_000;
  const NOIBU_SDK_TIMEOUT = 30_000;
  const NOIBU_SDK_RETRY_INTERVAL = 1_000;
  let capturedEmail;
  let attributeSent = false;
  let chatDiscoveryObserver;
  let chatDiscoveryTimeout;
  let chatWidgetObserver;
  let chatWidgetTimeout;
  let noibuReadyListener;
  let noibuReadyTimeout;
  let noibuRetryInterval;

  function getEmail(value) {
    const match = String(value || '').trim().match(EMAIL_PATTERN);
    return match ? match[0].toLowerCase() : null;
  }

  function stopChatWatching() {
    chatDiscoveryObserver?.disconnect();
    chatWidgetObserver?.disconnect();
    clearTimeout(chatDiscoveryTimeout);
    clearTimeout(chatWidgetTimeout);
    chatDiscoveryObserver = undefined;
    chatWidgetObserver = undefined;
  }

  function sendAttribute() {
    if (attributeSent || !capturedEmail || !window.NOIBUJS?.addCustomAttribute) {
      return false;
    }

    try {
      window.NOIBUJS.addCustomAttribute(ATTRIBUTE_NAME, capturedEmail);
      attributeSent = true;
      return true;
    } catch {
      // The SDK can be replaced while initializing; the ready event or next capture retries.
      return false;
    }
  }

  function waitForNoibuSdk() {
    if (sendAttribute() || noibuReadyListener) {
      return;
    }

    noibuReadyListener = () => {
      if (sendAttribute()) {
        stopNoibuSdkWait();
      }
    };
    window.addEventListener('noibuSDKReady', noibuReadyListener, { once: true });
    noibuRetryInterval = window.setInterval(() => {
      if (sendAttribute()) {
        stopNoibuSdkWait();
      }
    }, NOIBU_SDK_RETRY_INTERVAL);
    noibuReadyTimeout = window.setTimeout(() => {
      stopNoibuSdkWait();
    }, NOIBU_SDK_TIMEOUT);
  }

  function stopNoibuSdkWait() {
    window.removeEventListener('noibuSDKReady', noibuReadyListener);
    clearInterval(noibuRetryInterval);
    clearTimeout(noibuReadyTimeout);
    noibuReadyListener = undefined;
    noibuRetryInterval = undefined;
    noibuReadyTimeout = undefined;
  }

  function captureEmail(value) {
    const email = getEmail(value);
    if (!email || capturedEmail) {
      return;
    }

    capturedEmail = email;
    stopChatWatching();
    waitForNoibuSdk();
  }

  function watchContactForm() {
    const field = document.querySelector('form[action*="/contact"] input[name="contact[email]"]');
    if (!field) {
      return;
    }

    field.addEventListener('change', () => captureEmail(field.value));
    field.form?.addEventListener('submit', () => captureEmail(field.value));
  }

  function startChatObservation(root) {
    if (chatWidgetObserver || capturedEmail) {
      return;
    }

    const watchChatFields = () => {
      if (capturedEmail) {
        stopChatWatching();
        return;
      }

      const field = root.querySelector('input[name="chat-message-input"]');
      const sendButton = root.querySelector('button[aria-label="Send message"]');

      if (field && !field.dataset.noibuCustomerEmailWatched) {
        field.dataset.noibuCustomerEmailWatched = 'true';
        field.addEventListener('change', () => captureEmail(field.value));
        field.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            captureEmail(field.value);
          }
        });
      }

      if (sendButton && !sendButton.dataset.noibuCustomerEmailWatched) {
        sendButton.dataset.noibuCustomerEmailWatched = 'true';
        sendButton.addEventListener('click', () => captureEmail(field?.value));
      }
    };

    watchChatFields();
    chatWidgetObserver = new MutationObserver(watchChatFields);
    chatWidgetObserver.observe(root, { childList: true, subtree: true });
    chatWidgetTimeout = window.setTimeout(stopChatWatching, CHAT_CAPTURE_TIMEOUT);
  }

  function watchChatWidget() {
    const widget = document.querySelector('#redo-chat-widget');
    const root = widget?.shadowRoot;
    if (!root) {
      return false;
    }

    chatDiscoveryObserver?.disconnect();
    clearTimeout(chatDiscoveryTimeout);
    root.addEventListener('click', (event) => {
      if (event.target.closest('button[aria-label="Open chat widget"]')) {
        startChatObservation(root);
      }
    });
    return true;
  }

  function startChatWidgetDiscovery() {
    if (watchChatWidget()) {
      return;
    }

    chatDiscoveryObserver = new MutationObserver(() => {
      watchChatWidget();
    });
    chatDiscoveryObserver.observe(document.documentElement, { childList: true, subtree: true });
    chatDiscoveryTimeout = window.setTimeout(stopChatWatching, CHAT_DISCOVERY_TIMEOUT);
  }

  function initialize() {
    watchContactForm();
    startChatWidgetDiscovery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
